import { useEffect, useMemo } from "react"
import { Radio, Segmented } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLocationDot } from "@fortawesome/free-solid-svg-icons"
import PageHeader from "../../components/PageHeader"
import TransportList from "../../components/TransportList"
import Disclaimer from "../../components/Disclaimer"
import GeneralHelper from "../../helpers/general"
import AnalyticsHelper from "../../helpers/analytics"
import "../../components/Filter/Filter.less"
import "./FromHkustPage.less"

const TABS = [
    { label: 'Bus Stops', value: 'bus-stops' },
    { label: 'Destination', value: 'destination' }
]

const FromHkustPage = (props) => {
    const { history, match, pageProps, getBusStops, getLocations, getBusStopsEta, getBusRoutesEta, resetMeta } = props
    const { bus_stops, locations } = pageProps

    const tab = match?.params?.tab === 'destination' ? 'destination' : 'bus-stops'
    const slug = match?.params?.slug

    useEffect(() => {
        getBusStops({ type: 'hkust' })
        getLocations()
        return () => resetMeta()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // options for the currently selected tab
    const options = useMemo(() => {
        if (tab === 'destination') {
            return (locations || []).map(l => ({ label: l.name, value: l.slug, name: l.name }))
        }
        return (bus_stops || []).map(s => ({ label: s.name, value: s.slug, name: s.name }))
    }, [tab, bus_stops, locations])

    // ensure a slug is selected; default to first option
    useEffect(() => {
        if (!options.length) return
        const exists = options.some(o => o.value === slug)
        if (!exists) {
            history.replace(`/from-hkust/${tab}/${options[0].value}`)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, slug, tab])

    // fetch ETA for the selection + poll every 10s
    useEffect(() => {
        if (!slug || !options.some(o => o.value === slug)) return

        const fetchEta = () => {
            if (tab === 'destination') {
                const opt = options.find(o => o.value === slug)
                if (opt) getBusRoutesEta(GeneralHelper.objectToQueryString({ display_name: opt.name }))
            } else {
                getBusStopsEta(GeneralHelper.objectToQueryString({ slug }))
            }
        }

        fetchEta()
        const interval = setInterval(fetchEta, 10000)
        return () => clearInterval(interval)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab, slug, options])

    const handleTabChange = (value) => {
        AnalyticsHelper.track('select_tab', { section: 'from_hkust', tab: value })
        history.push(`/from-hkust/${value}`)
    }

    const handleSelect = (e) => {
        const value = e.target.value
        const opt = options.find(o => o.value === value)
        AnalyticsHelper.track(tab === 'destination' ? 'select_destination' : 'select_stop', {
            direction: 'from_hkust',
            slug: value,
            name: opt?.name
        })
        history.push(`/from-hkust/${tab}/${value}`)
    }

    const handleReload = () => {
        AnalyticsHelper.track('reload_eta', { section: 'from_hkust', tab, slug })
        if (!slug || !options.some(o => o.value === slug)) return
        if (tab === 'destination') {
            const opt = options.find(o => o.value === slug)
            if (opt) getBusRoutesEta(GeneralHelper.objectToQueryString({ display_name: opt.name }))
        } else {
            getBusStopsEta(GeneralHelper.objectToQueryString({ slug }))
        }
    }

    return (
        <div className="container">
            <PageHeader icon={<FontAwesomeIcon icon={faLocationDot} />} title="From HKUST" onReload={handleReload} />

            <div className="filter">
                <Segmented
                    value={tab}
                    onChange={handleTabChange}
                    options={TABS}
                    className="filter-category"
                    block
                />
                <Radio.Group
                    block
                    options={options}
                    value={slug}
                    optionType="button"
                    buttonStyle="solid"
                    onChange={handleSelect}
                    className="filter-options"
                />
            </div>

            <TransportList style={{ marginBlockStart: 24 }} props={props} />

            <Disclaimer />
        </div>
    )
}

export default FromHkustPage
